import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from "../notification-service/notification.service";
import { ExceptionDetail } from "../../models/dtos/ExceptionDetail";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";

/**
 * API Helper Service
 *
 * @deprecated This service is being phased out in favor of HttpErrorInterceptor.
 * New code should rely on the global error handling instead.
 *
 * This service is kept for backward compatibility with existing code.
 * The HttpErrorInterceptor now handles most error scenarios automatically.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiHelperService {

  constructor(
    public notificationService: NotificationService,
    public router: Router,
    public authService: AuthService
  ) { }

  /**
   * @deprecated Use HttpErrorInterceptor instead. This method will be removed in a future version.
   *
   * Legacy error handler for backward compatibility.
   * Most errors are now handled automatically by HttpErrorInterceptor.
   */
  public onError(err: any): void {
    // Note: Most errors are now handled by HttpErrorInterceptor
    // This is kept for backward compatibility only

    if (!(err instanceof HttpErrorResponse)) {
      console.error('Non-HTTP error passed to onError:', err);
      this.notificationService.showError("ERROR.UNKNOWN");
      return;
    }

    // 401 errors are handled by HttpErrorInterceptor, but kept here for legacy code
    if (err.status === 401) {
      this.notificationService.showError("ERROR.SESSION_TIMEOUT");
      this.authService.logout({
        logoutParams: { returnTo: window.location.origin }
      });
      return;
    }

    // Generic error handling
    if (!err.error || !err.error.langKey) {
      this.notificationService.showError("ERROR.UNKNOWN");
      return;
    }

    this.notificationService.showError(err.error.langKey);
    console.error('API Error:', err);
  }
}
